import { ArrowLeftIcon, PencilSimpleIcon, PrinterIcon } from '@phosphor-icons/react';
import { FlexContainer } from '@act/storybook';
import { Link, useNavigate } from 'react-router-dom';
import { useReportsPermissions } from '../hooks/useReportsPermissions.hook';
import ReportIconActionButton from './ReportIconActionButton';

const REPORT_ICON_SIZE = 20;

export interface ReportViewToolbarProps {
  reportId: string;
}

/**
 * Minimal view-route header with back navigation and edit/print actions.
 * @param props - Report identity for action links.
 */
export const ReportViewToolbar = ({ reportId }: ReportViewToolbarProps) => {
  const navigate = useNavigate();
  const { canEdit } = useReportsPermissions();

  return (
    <div className="reports-view-toolbar reports-reading-route-header">
      <FlexContainer
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        height="auto"
        overflowAllVisible={true}
      >
        <Link to="/" className="reports-view-toolbar__back" aria-label="Back to reports">
          <ArrowLeftIcon size={REPORT_ICON_SIZE} aria-hidden={true} />
        </Link>

        <FlexContainer
          direction="row"
          alignItems="center"
          gap={0.5}
          height="auto"
          overflowAllVisible={true}
        >
          {canEdit ? (
            <ReportIconActionButton
              label="Edit"
              trackingName="reports-view-edit"
              onClick={() => navigate(`/${reportId}`)}
            >
              <PencilSimpleIcon size={REPORT_ICON_SIZE} />
            </ReportIconActionButton>
          ) : null}
          <ReportIconActionButton
            label="Print / Save as PDF"
            trackingName="reports-view-print"
            onClick={() => navigate(`/${reportId}/print`)}
          >
            <PrinterIcon size={REPORT_ICON_SIZE} />
          </ReportIconActionButton>
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};
